import {useClickOutside} from "hooks";
import {useRef, useState} from "react";

function usePlayAssetPreview() {
  const clickOustsideRef = useRef();
  const exceptRef = useRef();

  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(!isPlaying);
  };

  const stopPlay = () => {
    setIsPlaying(false);
  };

  useClickOutside(clickOustsideRef, stopPlay, exceptRef);

  return {handlePlay, stopPlay, isPlaying};
}

export default usePlayAssetPreview;
